export default __webpack_public_path__ + "static/media/icon-back.9dd57e97.svg";